<template>
  <div class="w-full h-full horizontal layout center">
    <div class="w-full" v-if="isShowChart">
      <div class="mx-32 d-flex match-pair-content">
        <div class="flex-grow w-6/12">
          <Prompt
            v-for="(item, index) in prompts"
            :key="index"
            :color="item.color"
            :text="item.title"
            :image="item.imageCropped"
            :index="item.index"
            position="left"
            :showAnswer="showAnswer"
            :hideConnect="!item.pairTitle"
            :bg-color="slideActive.baseColour"
          />
        </div>

        <div class="flex-grow w-6/12">
          <transition-group name="flip-list">
            <Prompt
              v-for="item in answersOptions"
              :key="item.id"
              :color="item.color"
              :text="item.pairTitle"
              :image="item.pairImageCropped"
              :order="item.key"
              position="right"
              :showAnswer="showAnswer"
              :showAnswerColor="showAnswerColor"
              :class="{'promt-visible': item.hidden}"
              :bg-color="slideActive.baseColour"
            />
          </transition-group>
        </div>
      </div>
      <div class="match-answer horizontal layout center center-justified">
        <Answer v-if="canShowQuizResult" />
      </div>
    </div>

    <CanvasQuestionImage v-if="!isShowChart" />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Prompt from '@/components-v2/presentation-editor/match-pairs/Prompt.vue'
import Answer from '@/components-v2/presentation-editor/match-pairs/Answer.vue'
import CanvasQuestionImage from '@/components-v2/presentation-editor/middle/CanvasQuestionImage.vue'
import util from '@/util'
import EventBus from '@/eventBus'
import QuizStatuses from '@/constant/QuizStatuses'

export default {
  components: {
    Prompt,
    Answer,
    CanvasQuestionImage,
  },
  data() {
    return {
      answersOptions: [],
      showAnswer: false,
      showAnswerColor: false,
      prompts: [],
    }
  },
  computed: {
    ...mapState({
      slideActive: (state) => state.slideActive,
      presentation: (state) => state.presentation,
    }),
    isShowChart() {
      const presenting = this.$store.getters.isPresenting
      const { slideActive } = this.$store.state
      const noQuestionImg = !slideActive.showQuestionImage || !slideActive.image

      if ((!presenting && noQuestionImg) || (slideActive.type === 'pickAnswer' && presenting && !this.$store.state.sharePresentation) || (slideActive.type === 'pickAnswer' && this.$store.state.sharePresentation && noQuestionImg)) {
        return true
      }
      return false
    },
    canShowQuizResult() {
      const isResultScreen = this.slideActive.quizStatus === QuizStatuses.RESULT_SCREEN
      if (!this.presentation.manualRevealCorrectAnswers) {
        return isResultScreen
      }
      return isResultScreen && this.slideActive.showCorrectOption
    },
  },
  watch: {
    'slideActive.quizStatus': function resultUpdated() {
      if (this.slideActive.quizStatus === QuizStatuses.RESULT_SCREEN) {
        setTimeout(() => {
          this.handleShowCorrectAnswer()
        }, 500)
      }
    },
    'slideActive.showCorrectOption': function watchShowCorrectOption(showCorrectOption) {
      if (showCorrectOption) {
        setTimeout(() => {
          this.handleShowCorrectAnswer()
        }, 500)
      }
    },
  },
  mounted() {
    this.updateSlideOption()
    EventBus.$on('match-pairs-change', (options) => {
      this.updateSlideOption(options)
      this.handleShowDefault()
    })

    this.handleShowDefault()
    if (this.$store.state.sharePresentation) {
      this.slideActive.quizStatus = 5
      this.handleShowCorrectAnswer()
    }
  },
  destroyed() {
    EventBus.$off('match-pairs-change')
  },
  methods: {
    ...mapActions(['updateSlideActiveAction']),
    handleShowDefault() {
      if (!this.isShowDefault()) return
      const textPrompt = this.$i18nPresenter.t('Prompt...')
      const textAnswer = this.$i18nPresenter.t('Answer...')
      this.prompts = [
        {
          id: 1, index: 1, title: textPrompt, color: util.getAhaColor(0),
        },
        {
          id: 2, index: 2, title: textPrompt, color: util.getAhaColor(1),
        },
        {
          id: 3, index: 3, title: textPrompt, color: util.getAhaColor(2),
        },
        {
          id: 4, index: 4, title: textPrompt, color: util.getAhaColor(3),
        },
      ]
      this.answersOptions = [
        { id: 1, key: 'A', pairTitle: textAnswer },
        { id: 2, key: 'B', pairTitle: textAnswer },
        { id: 3, key: 'C', pairTitle: textAnswer },
        { id: 4, key: 'D', pairTitle: textAnswer },
      ]
    },
    isShowDefault() {
      let isShow = true
      this.slideActive.SlideOptions.forEach((item) => {
        if (item.title || item.pairTitle || item.image || item.pairImage) isShow = false
      })
      return isShow
    },
    setKeyOption() {
      this.answersOptions.map((item, key) => {
        if (key === 0) item.key = 'A'
        if (key === 1) item.key = 'B'
        if (key === 2) item.key = 'C'
        if (key === 3) item.key = 'D'
        return item
      })
    },

    handleShowCorrectAnswer() {
      if (!this.canShowQuizResult) {
        return
      }
      this.prepareCorrectAnswer()
      setTimeout(() => {
        this.showAnswer = true
        setTimeout(() => {
          this.showAnswerColor = true
        }, 500)
      }, 1500)
    },
    prepareCorrectAnswer() {
      const listCorrect = []
      this.prompts.forEach((item) => {
        const index = this.answersOptions.findIndex((option) => {
          return option.id === item.id
        })

        if (index !== -1) {
          listCorrect.push(this.answersOptions[index])
        } else {
          const indexInSlideOption = this.getOptions().findIndex((option) => {
            return option.id === item.id
          })
          if (indexInSlideOption !== -1) {
            const optionInCorrect = this.getOptions()[indexInSlideOption]
            optionInCorrect.hidden = true
            listCorrect.push(optionInCorrect)
          }
        }
      })
      this.answersOptions.forEach((item) => {
        const index = this.prompts.findIndex((option) => {
          return option.id === item.id
        })
        if (index === -1) {
          listCorrect.push(item)
        }
      })
      this.answersOptions = listCorrect
    },
    getOptions() {
      return this.slideActive.SlideOptions.filter((item) => item.id)
    },
    updateSlideOption(options) {
      const opts = options || this.getOptions()
      this.updateSlideOptionV2(opts)
    },

    updateSlideOptionV2(options) {
      this.prompts = options.filter((item) => item.title || item.image)
      this.prompts.map((item, key) => {
        item.index = key + 1
        item.color = util.getAhaColor(key)
        return item
      })
      this.answersOptions = util.shuffleArrayWithSeed(
        options.filter((item) => item.pairTitle || item.pairImage),
        this.slideActive.id,
      )
      this.setKeyOption()
    },
  },
}
</script>

<style lang="scss" scoped>
.flip-list-move {
  transition: transform 1.5s;
}
.match-answer {
  height: 50px;
  margin-top: 6px;
}

.promt-visible {
  visibility: hidden;
}
</style>
